import * as ReactHelmetAsync from 'react-helmet-async';
const Helmet = ReactHelmetAsync.Helmet || (ReactHelmetAsync as any).default?.Helmet;
import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { PageHero } from '@/components/sections/PageHero';
import { Gallery as GalleryComponent } from '@/components/ui/Gallery';
import { useHomeData } from '@/hooks/useHomeData';

export function Gallery() {
  const { homeData } = useHomeData();

  return (
    <>
      <Helmet>
        <title>Gallery - Aircraft Photos & Flying Adventures | Total Tailwheel</title>
        <meta
          name="description"
          content="Browse our gallery featuring our beautiful 1954 Cessna 170B tailwheel aircraft and flying adventures throughout New England."
        />
        <meta name="keywords" content="tailwheel aircraft photos, Cessna 170B gallery, flight training photos, New England flying, tailwheel gallery" />
        <meta property="og:title" content="Gallery - Aircraft Photos & Flying Adventures | Total Tailwheel" />
        <meta property="og:description" content="Browse our gallery featuring our beautiful 1954 Cessna 170B and flying adventures throughout New England." />
        <link rel="canonical" href="https://totaltailwheel.com/gallery" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <Navigation />
        
        <PageHero title="Gallery" />

        {/* Gallery Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md">
              <h2 className="text-3xl font-medium text-primary mb-8 text-center md:text-left">Our Aircraft & Adventures</h2>
              <p className="text-lg text-foreground/80 leading-relaxed mb-6">
                Take a look at our beautiful 1954 Cessna 170B and the amazing places we've flown throughout New England. 
                From grass strips to coastal destinations, tailwheel flying opens up a world of unique airports and adventures.
              </p>
              <div className="mb-8">
                <div className="bg-gradient-to-r from-primary/5 to-secondary/5 border border-primary/20 rounded-lg p-6 text-center">
                  <p className="text-foreground/70 mb-4 text-sm">
                    Every photo tells a story of adventure and discovery
                  </p>
                  <a 
                    href="/blog"
                    className="inline-flex items-center gap-3 bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-all duration-200 font-medium shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                  >
                    <span>Read the Stories Behind These Photos</span>
                    <span className="text-lg">✈️</span>
                  </a>
                </div>
              </div>
              <GalleryComponent 
                images={homeData.about.gallery} 
                columns={3}
                className="max-w-4xl mx-auto"
              />
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}